import { createApp } from 'vue'
import App from './App.vue'
import mixins from './mixins';
import router from './router'
import store from './store';

// createApp(App).use(router).mount('#app')
const app = createApp(App);
app.use(router);
app.mixin(mixins);
app.use(store);
app.mount('#app');

window.Kakao.init("0466aa77fe2c7bfb41f6e2207401822a");
